export default "__VITE_ASSET__CUkP7zbb__"